import { render, staticRenderFns } from "./DefaultInfo.vue?vue&type=template&id=05678632&scoped=true"
import script from "./DefaultInfo.vue?vue&type=script&lang=js"
export * from "./DefaultInfo.vue?vue&type=script&lang=js"
import style0 from "./DefaultInfo.vue?vue&type=style&index=0&id=05678632&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05678632",
  null
  
)

export default component.exports